import accountSafe from './cn/account-safe'
import affiliate from './cn/affiliate'
import bankTransfer from './cn/bankTransfer'
import cart from './cn/cart'
import cartAndWarehouse from './cn/cartAndWarehouse'
import common from './cn/common'
import consult from './cn/consult'
import debt from './cn/debt'
import distribution from './cn/distribution'
import emailSend from './cn/emailSend'
import estimation from './cn/estimation'
import form from './cn/form'
import home from './cn/home'
import kol from './cn/kol'
import order from './cn/order'
import orderDetail from './cn/orderDetail'
import packages from './cn/package'
import pay from './cn/pay'
import pecenter from './cn/pecenter'
import points from './cn/points'
import previewPackage from './cn/previewPackage.json'
import previewPackageOptimize from './cn/previewPackageOptimize'
import product from './cn/product'
import returnChange from './cn/returnChange'
import search from './cn/search'
import shareCoupon from './cn/shareCoupon'
import sharePackage from './cn/sharePackage'
import shoppingGuide from './cn/shoppingGuide'
import site from './cn/site'
import status from './cn/status'
import storage from './cn/storage'
import tag from './cn/tag'
import tips from './cn/tips'
import transport from './cn/transport'
import uniOrder from './cn/uniOrder'
import vip from './cn/vip'
import warnTips from './cn/warnTips'
export default {
  'account-safe': accountSafe,
  form,
  home,
  search,
  cart,
  product,
  order,
  pecenter,
  pay,
  common,
  estimation,
  packages,
  orderDetail,
  warnTips,
  status,
  tips,
  storage,
  distribution,
  uniOrder,
  bankTransfer,
  site,
  consult,
  transport,
  previewPackage,
  sharePackage,
  debt,
  previewPackageOptimize,
  points,
  shareCoupon,
  shoppingGuide,
  tag,
  cartAndWarehouse,
  affiliate,
  returnChange,
  kol,
  vip,
  emailSend,
}
